import React from 'react'
import {PrimaryRoomOffer} from 'components/Accommodation/Offers/PrimaryRoomOffer'
import {useAccommodationTopOffers} from 'components/Accommodation/Offers/useAccommodationTopOffers'
import {useOfferContainer} from 'hooks/useOfferContainer'

import isBofhOffer from '@vio/core/src/offer/business/isBofhOffer'

import {BottomCTA} from '../BottomCTA'
import {DesktopAPClickerCTALoading} from './DesktopAPClickerCTALoading'

interface Props {
  hotelId: string
  component: string
  sourceComponent: string
  isLoading?: boolean
}

export const DesktopAPClickerCTA = ({
  hotelId,
  component,
  sourceComponent,
  isLoading
}: Props) => {
  const {offerEntity} = useAccommodationTopOffers({hotelId})
  const {primaryOffer} = useOfferContainer({offerEntity, hotelId})

  if (isLoading) {
    return <DesktopAPClickerCTALoading />
  }

  if (!primaryOffer) return null

  if (isBofhOffer(primaryOffer)) {
    return <PrimaryRoomOffer hotelId={hotelId} component={component} />
  }

  return (
    <BottomCTA
      hotelId={hotelId}
      sourceComponent={sourceComponent}
      noBorderStyles
      hideCallToBook
    />
  )
}
